export default [
  {
    path: '/home',
      name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '../home/Home')
  }
]



// WEBPACK FOOTER //
// ./src/pages/home/router.js